const measure = (stack) => {
  stack.style.setProperty('--drv-amain-stack-h', `${stack.offsetHeight}px`);
};

const fit = (stack) => {
  const side = stack.closest('.drv-amain__side');
  const body = side && side.parentElement.querySelector(':scope > .drv-amain__body');
  if (!body) return;
  side.classList.toggle('drv-amain__side--scroll', stack.scrollHeight > body.offsetHeight + 1);
  side.classList.toggle('drv-amain__side--more', stack.scrollTop + stack.clientHeight < stack.scrollHeight - 1);
};

const shown = (el) => !!el && el.getClientRects().length > 0;

const syncToc = (toc) => {
  toc.querySelectorAll('a[href^="#"]').forEach((link) => {
    const item = link.closest('li');
    if (!item) return;
    const id = decodeURIComponent(link.getAttribute('href').slice(1));
    item.hidden = !shown(document.getElementById(id));
  });
  toc.querySelectorAll('.drv-toc__l2').forEach((list) => {
    list.hidden = !list.querySelector(':scope > li:not([hidden])');
  });
  toc.querySelectorAll('.drv-toc__l1').forEach((item) => {
    const own = item.querySelector(':scope > a');
    if (!own) item.hidden = !item.querySelector('.drv-toc__l2:not([hidden])');
  });
};

let tocFrame = 0;
const syncTocs = () => {
  cancelAnimationFrame(tocFrame);
  tocFrame = requestAnimationFrame(() => document.querySelectorAll('.drv-toc').forEach(syncToc));
};

const init = () => {
  document.querySelectorAll('[data-drv-stack]').forEach((stack) => {
    if (stack.dataset.drvStackReady) return;
    stack.dataset.drvStackReady = '1';
    const update = () => {
      measure(stack);
      fit(stack);
    };
    update();
    stack.addEventListener('scroll', () => fit(stack), { passive: true });
    if (!('ResizeObserver' in window)) return;
    const observer = new ResizeObserver(update);
    [stack, ...stack.children, stack.closest('.drv-amain__grid')?.querySelector(':scope > .drv-amain__body')]
      .filter(Boolean)
      .forEach((el) => observer.observe(el));
  });
  syncTocs();
};

window.addEventListener('resize', syncTocs);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
document.addEventListener('shopify:section:load', init);
